































































































import Vue from "vue";
import ThePopup from "@/components/root/popup/ThePopup.vue";
import Pending from "@/components/root/Pending.vue";
import SvgSpirte from "@/components/root/SvgSprite.vue";
import Tooltip from "@/components/root/tooltip/ToolTip.vue";
import AppNavBar from "@/components/root/navbar/AppNavBar.vue";
import AppHero from "@/components/root/hero/AppHero.vue";
import TheModal from "@/components/root/modal/TheModal.vue";
import TheToast from "@/components/root/toast/TheToast.vue";
import { computed, onMounted, ref } from "@vue/composition-api";
import TheDrilldownMenu from "@/components/root/drilldown-menu/TheDrilldownMenu.vue";
import { SharedState } from "./common/state";
import MainLoader from "./components/MainLoader.vue";
import Signiture from "./components/Signiture.vue";
import ThirdPartyModal from "./components/root/third-party/index.vue";
import MediaHero from "./components/root/media-hero/MediaHero.vue";
import TrialStrip from "./components/root/navbar/TrialStrip.vue";

export default Vue.extend({
  components: {
    SvgSpirte,
    Pending,
    TheModal,
    AppNavBar,
    TheToast,
    Tooltip,
    ThePopup,
    TheDrilldownMenu,
    MainLoader,
    Signiture,
    AppHero,
    ThirdPartyModal,
    MediaHero,
    TrialStrip,
  },
  setup(_) {
    const {
      loggedUser,
      onReady,
      isShowAuditlogModal,
      selectedTimeFrameDisplayName,
      isOrgActive,
      is_org_suspended,
    } = SharedState;
    const is_not_supported_screen_size = ref(false);
    const isInit = ref(false);
    const router_transition_name = ref("fade");
    onMounted(() => {
      onReady(() => (isInit.value = true));
    });

    const orgContactEmail = computed(() => loggedUser.value.orgContactEmail);

    const isShowUI = computed(() => loggedUser.value.showUI);
    const is_on_trial = computed(
      () => SharedState.loggedUser.value.trial.active
    );

    const is_logged = computed(() => SharedState.isUserLogged.value);

    onMounted(() => {
      is_not_supported_screen_size.value = window.innerWidth <= 600;
      window.addEventListener("resize", () => {
        is_not_supported_screen_size.value = window.innerWidth <= 600;
      });
    });

    return {
      orgContactEmail,
      isOrgActive,
      isShowAuditlogModal,
      isShowUI,
      isInit,
      Z: SharedState.typesByCategories,
      selectedTimeFrameDisplayName,
      is_on_trial,
      is_logged,
      router_transition_name,
      is_not_supported_screen_size,
      is_org_suspended,
    };
  },
});
